import FortuneWheelImage from '@/assets/images/fortune-wheel.webp'
import CoinIcon from '@/assets/images/icons/gold-coin-icon-s3.webp'
import TicketImage from '@/assets/images/emojis/emoji-ticket.png'
import StarImage from '@/assets/images/premium.png'
import OfflineProfitImage from '@/assets/images/offline-profit.png'
import ProfitX2Image from '@/assets/images/prize-cards/php2x.webp'
import { allSpecialCurrenciesConfig } from '@/config/special-currencies'
import { computed } from 'vue'

// Comprehensive reward image map
export const rewardImageMap = computed<Record<string, string>>(() => ({
  // Standard rewards
  spins: FortuneWheelImage,
  spin: FortuneWheelImage,
  goldenCoins: CoinIcon,
  goldenCoin: CoinIcon,
  giveawayTickets: TicketImage,
  dropeeStars: StarImage,
  offlineProfit: OfflineProfitImage,
  profitX2: ProfitX2Image,
  // Special currencies
  ...Object.fromEntries(
    Object.entries(allSpecialCurrenciesConfig.value).map(([key, value]) => [key, value.image])
  ),
}))

// Get reward image by currency ID (handles various naming conventions)
export function getRewardImage(currencyId: string): string | undefined {
  return rewardImageMap.value[currencyId]
}
